var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEnginewhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.525 10.5h-1.951v1h-.975V9.31a.998.998 0 00-.54-.895l-1.578-.81a.963.963 0 00-.436-.105h-2.323v-1h1.95v-1H8.846v1h1.951v1H8.515a.951.951 0 00-.569.188L6.84 8.5H4.944v4H3.475v-3H2.5v7h.975v-3h1.469v4h2.743l2.301 1.795c.17.133.378.205.592.205h7.043a.989.989 0 00.976-1v-1h.975v1h1.95a.989.989 0 00.976-1v-6c0-.552-.437-1-.975-1zm-9.754-4h.976v1h-.976v-1zm9.754 11h-.976v-1H18.6a.989.989 0 00-.976 1v1H10.58l-2.301-1.795a.966.966 0 00-.592-.205H5.92v-7h.921a.95.95 0 00.568-.188L8.515 8.5h7.53l1.578.81v2.19c0 .552.437 1 .976 1h1.95v-1h.976v6z",
    fill: "#FAFAFA",
    fillRule: "evenodd"
  })));
}

export default SvgEnginewhite;